export interface TaskSettingInterface {
  /**
   * 直播任务-直播地址
   */
  url?: string
  /**
   * 直播任务-直播日期时间
   */
  date?: string
  /**
   * 直播任务-开始时间
   */
  startTime?: string
  /**
   * 直播任务-结束时间
   */
  endTime?: string
  /**
   * 报名任务-报名项最多选择
   */
  maxSelectLimit?: number
  /**
   * 报名任务-报名项最少选择
   */
  minSelectLimit?: number
  /**
   * 报名任务-是否允许学生修改
   */
  allowEdit?: boolean
}

export class TaskSetting implements TaskSettingInterface {
  /**
   * 直播任务-直播地址
   */
  url?: string
  /**
   * 直播任务-直播日期时间
   */
  date?: string
  /**
   * 直播任务-开始时间
   */
  startTime?: string
  /**
   * 直播任务-结束时间
   */
  endTime?: string
  /**
   * 报名任务-报名项最多选择
   */
  maxSelectLimit?: number
  /**
   * 报名任务-报名项最少选择
   */
  minSelectLimit?: number
  /**
   * 报名任务-是否允许学生修改
   */
  allowEdit?: boolean

  constructor(props: TaskSettingInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      url: _url,
      date: _date,
      startTime: _startTime,
      endTime: _endTime,
      maxSelectLimit: _maxSelectLimit,
      minSelectLimit: _minSelectLimit,
      allowEdit: _allowEdit,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.url = _url
    this.date = _date
    this.startTime = _startTime
    this.endTime = _endTime
    this.maxSelectLimit = _maxSelectLimit
    this.minSelectLimit = _minSelectLimit
    this.allowEdit = _allowEdit
  }
}
